export const LANDING_CUBE_VERTICES = [
  [-1, -1, -1],
  [1, -1, -1],
  [1, 1, -1],
  [-1, 1, -1],
  [-1, -1, 1],
  [1, -1, 1],
  [1, 1, 1],
  [-1, 1, 1],
]

export const LANDING_CUBE_EDGES = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 0],
  [4, 5],
  [5, 6],
  [6, 7],
  [7, 4],
  [0, 4],
  [1, 5],
  [2, 6],
  [3, 7],
]

export const LANDING_CUBE_CONFIG = {
  CAMERA_DISTANCE: 4,
  CUBE_VIEWPORT_RATIO: 0.5,
  HOVER_MAX_YAW: Math.PI / 9,
  HOVER_MAX_PITCH: Math.PI / 14,
  ORBIT_SENSITIVITY: Math.PI / 540,
  MAX_PITCH: Math.PI / 2.2,
  SPIN_DAMPING: 2.4,
  SPIN_EPSILON: 0.001,
  INERTIA_RELEASE_MAX_AGE_MS: 70,
  INERTIA_MIN_SPEED: 0.6,
  INERTIA_MAX_SPEED: 14,
  MAX_PIXEL_RATIO: 2,
  GLITCH_SHIFT_PX: 2.4,
  BASE_STROKE_FALLBACK: "#3b82f6",
}
